import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, MapPin, Phone, Mail, Facebook } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export const Footer = () => {
  const {
    t
  } = useLanguage();
  return <footer className="bg-pink-lighter pt-16 pb-8 border-t border-pink-100" data-id="element-47">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-49">
          {/* Brand */}
          <div className="flex flex-col items-start" data-id="element-50">
            <img src="https://cdn.magicpatterns.com/uploads/s45KS2J3qfedmHm2iX4JF5/ChatGPT_Image_May_5,_2026,_05_53_25_PM.png" alt="Lucy Cleaning Services" className="h-16 object-contain mb-4" data-id="element-51" />
            <p className="text-gray-600 mb-6 max-w-sm" data-id="element-52">{t('footer.tagline')}</p>
            <div className="flex items-center gap-2 text-pink-primary mb-6" data-id="element-53">
              <Heart className="w-5 h-5 fill-current" data-id="element-54" />
              <span className="font-script text-2xl" data-id="element-55">Lucy</span>
            </div>
            <div data-id="element-56">
              <h4 className="text-sm font-semibold text-navy mb-3" data-id="element-57">
                {t('footer.followUs')}
              </h4>
              <div className="flex gap-3" data-id="element-58">
                <a href="https://web.facebook.com/profile.php?id=61589125539642" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-10 h-10 rounded-full bg-white border border-pink-100 flex items-center justify-center text-pink-primary hover:bg-pink-primary hover:text-white transition-colors shadow-sm" data-id="element-59">
                  <Facebook className="w-5 h-5" data-id="element-60" />
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-61">
            <h3 className="font-semibold text-navy text-lg mb-6" data-id="element-62">
              {t('footer.quickLinks')}
            </h3>
            <ul className="space-y-4" data-id="element-63">
              <li data-id="element-64">
                <Link to="/" className="text-gray-600 hover:text-pink-primary transition-colors" data-id="element-65">
                  {t('nav.home')}
                </Link>
              </li>
              <li data-id="element-66">
                <Link to="/services" className="text-gray-600 hover:text-pink-primary transition-colors" data-id="element-67">
                  {t('nav.services')}
                </Link>
              </li>
              <li data-id="element-68">
                <Link to="/about" className="text-gray-600 hover:text-pink-primary transition-colors" data-id="element-69">
                  {t('nav.about')}
                </Link>
              </li>
              <li data-id="element-70">
                <Link to="/booking" className="text-gray-600 hover:text-pink-primary transition-colors" data-id="element-71">
                  {t('nav.bookNow')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-72">
            <h3 className="font-semibold text-navy text-lg mb-6" data-id="element-73">
              {t('footer.contact')}
            </h3>
            <ul className="space-y-4" data-id="element-74">
              <li className="flex items-start gap-3 text-gray-600" data-id="element-75">
                <MapPin className="w-5 h-5 text-pink-primary shrink-0 mt-0.5" data-id="element-76" />
                <span data-id="element-77">{t('contact.address')}</span>
              </li>
              <li className="flex items-center gap-3 text-gray-600" data-id="element-78">
                <Phone className="w-5 h-5 text-pink-primary shrink-0" data-id="element-79" />
                <span data-id="element-80">{t('contact.phone')}</span>
              </li>
              <li className="flex items-center gap-3 text-gray-600" data-id="element-81">
                <Mail className="w-5 h-5 text-pink-primary shrink-0" data-id="element-82" />
                <span data-id="element-83">{t('contact.email')}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-pink-200 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-84">
          <p className="text-gray-500 text-sm" data-id="element-85">
            © {new Date().getFullYear()} Lucy Cleaning Services.{' '}
            {t('footer.rights')}
          </p>
          <div className="flex items-center gap-1 text-sm text-gray-500" data-id="element-86">
            Made with{' '}
            <Heart className="w-4 h-4 text-pink-primary fill-current mx-1" data-id="element-87" /> in
            Massachusetts
          </div>
        </div>
      </div>
    </footer>;
};